<template>
<v-dialog :fullscreen="canShowFullScreen()"  v-if="model.id != undefined && (this.pdf || this.images.length > 0 || this.youtubeLink != '')" v-model="dialog" :max-width="model && model.type ==TYPE_YOUTUBE ? 680 : 1100">
  <template v-slot:activator="{ on, attrs }">
    <v-btn color="primary" dark v-bind="attrs" v-on="on">
      {{ $t('presentation.presentation') }}
    </v-btn>
  </template>

  <v-progress-circular indeterminate color="primary" v-if="loading" spacing="pr-4"></v-progress-circular>
  <v-card v-else>

    <v-card-text v-if="model.type==TYPE_YOUTUBE && this.youtubeLink">
      <v-container>
        <v-layout>
            <iframe style="position: center" id="player" type="text/html" width="640" height="360"
                    :src="'https://www.youtube.com/embed/' + this.youtubeLink"
                    frameborder="0"></iframe>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-card-text v-else-if="model.type==TYPE_IMG">
      <div v-for="(i,key) in images" v-bind:key="key">
        <v-card>
          <v-img :contain="true" max-height="800" :src="i" aspect-ratio="1.0"></v-img>
        </v-card>
      </div>
    </v-card-text>

    <v-card-text v-else>
        <PDFViewer  :file="pdf" ></PDFViewer>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="green darken-1" flat="flat" @click="dialog = false">
        {{$t('base.submit')}}
      </v-btn>
    </v-card-actions>

  </v-card>
</v-dialog>
</template>

<script>
import http from '@/plugins/http'
import Cookies from 'js-cookie'
import PDFViewer from '@/components/pdf/Viewer'
import Vue from "vue";

const TYPE_YOUTUBE = 3
const TYPE_PDF = 2
const TYPE_IMG = 1

export default {
  components:{
    PDFViewer
  },
  props: ['schema'],
  data() {
    return {
      loading: true,
      dialog: false,
      images: [],
      pdf: null,
      model: {},
      youtubeLink: '',
      TYPE_IMG,
      TYPE_YOUTUBE

    }
  },
  computed: {

  },
  methods: {
    canShowFullScreen(){
      return window.screen.width < 650
    },
    loadImages(images) {
      images.forEach((image, key) =>
        http.get('presentation/file/' + image.name, {
          responseType: 'blob'
        })
        .then(data => {
          let urlCreator = window.URL || window.webkitURL;
          let imageUrl = urlCreator.createObjectURL(data.data);
          Vue.set(this.images, key, imageUrl)
          if (this.images.length == this.model.images.length) {
            this.loading = false
          }
        })
      )
    },
    loadPdf(data) {
      if(data == undefined || data[0] == undefined || data[0].name == undefined){
        return
      }
      let pdf = data[0]
      http.get('presentation/file/' + pdf.name, {
        responseType: 'blob'
      }).then(
          data => {
            this.pdf = new Blob([data.data],   { type: "application/pdf" })
            this.loading = false
          }
      )
    },
    loadPresentation() {
      let lang = Cookies.get('lang') || process.env.VUE_APP_LOCALE
      http.get(`schema/${this.$route.params.schemaId}/presentation/lang/${lang}`).
      then(({ data }) => {
        this.model = data
        this.dialog = true
        this.loading = true

        if(this.model.type == TYPE_IMG) {
          this.loadImages(data.images)
        }else if(this.model.type == TYPE_YOUTUBE){
          this.youtubeLink = data.images[0].name
          this.loading = false
        }else{
          this.loadPdf(data.images)
        }

      }).catch(() => this.loading = false)
    }
  },
  created() {
    if (this.schema.schema_presentation_id > 0) {
      this.loadPresentation()
    }
  }
}
</script>

<style scoped>
</style>
